import { render, staticRenderFns } from "./BookingSlots.vue?vue&type=template&id=76316b42&scoped=true"
import script from "./BookingSlots.vue?vue&type=script&lang=ts"
export * from "./BookingSlots.vue?vue&type=script&lang=ts"
import style0 from "./BookingSlots.vue?vue&type=style&index=0&id=76316b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76316b42",
  null
  
)

export default component.exports